<template>
  <div class="btn-float text-dark-grey mx-2 pointer">
    <font-awesome-icon
      class="text-size-24 mt-3"
      :icon="icon"
    />
    <div class="d-flex justify-content-center align-items-center text-size-10">{{label}}</div>
    <div 

    v-if="count > 0"
    class="btn-count d-flex justify-content-center align-items-center text-size-10">
      {{count}}
    </div>
  </div>
</template>
<script>
export default {
  name: 'BtnNavigation',
  props: ['label', 'icon', 'count'],
};
</script>
<style scoped lang="scss">
@import '@/styles/style.scss';

.btn-float {
  position: relative;
  width: 70px;
  height: 70px;
  background-color: white;
  color: $mid-grey;
  border-radius: 70px;
  text-align: center;
  box-shadow: 2px 2px 3px #999;
}

.btn-count {
  position: absolute;
  background-color: red;
  top: -5px;
  right: -5px;
  height: 25px;
  width: 25px;
  border-radius: 25px;
  color: white;
}
</style>